module.exports = __webpack_public_path__ + "images/xl-sichuan.jpg?0b61faac8b0f58f6176744d1aac3380d";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-sichuan.jpg
// module id = 209
// module chunks = 1